import antdEnUS from 'antd/es/locale/en_US';
import antdFrFR from 'antd/es/locale/fr_FR';
import antdViVN from 'antd/es/locale/vi_VN';
import en from './locales/en_US.json'
import fr from './locales/fr_FR.json'
import vi from './locales/vi_VN.json'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { THEME_CONFIG } from 'configs/AppConfig';
import { getStoredLocale } from './localeStorage';

const initialLocale = getStoredLocale(THEME_CONFIG.locale)

export const resources = {
    en: {
        translation: en,
        antd: antdEnUS
    },
    fr: {
        translation: fr,
        antd: antdFrFR
    },
    vi: {
        translation: vi,
        antd: antdViVN
    },
}

i18n.use(initReactI18next).init({
    resources,
    fallbackLng: THEME_CONFIG.locale,
    lng: initialLocale,
    interpolation: {
        escapeValue: false
    }
})

export default i18n;